// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader[data-v-5c6af47a]{align-items:center;background:hsla(0,0%,100%,.5);display:flex;flex-direction:column;height:100vh;justify-content:center;left:0;opacity:0;pointer-events:none;position:fixed;top:0;transition:opacity .3s;width:100vw;z-index:15000}.loader.active[data-v-5c6af47a]{opacity:1;transition-delay:.5s}.animation[data-v-5c6af47a]{height:80px!important;left:50%;position:fixed;top:50%;transform:translate(-50%,-50%);width:80px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
